import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  doubleHalf: {
    bottom: 0,
    right: -82,
  },
  rectangle: {
    left: -82,
    top: 0,
  },
  shape: {
    position: "absolute",
  },
  shapeContainer: {
    height: 196,
    overflow: "hidden",
  },
});

export { style };
